// utils/socket.js
import { io } from 'socket.io-client';

const socket = io('https://back.varankal.com', {
  autoConnect: false, // important so you can set userId dynamically
  transports: ['websocket'],
});

export default socket;
